import wbsBookingsApi from '../apis/wbsBookingsApi';

const deleteUserCategoriesService = async (
  categoryId: string,
): Promise<void> => {
  await wbsBookingsApi.delete(`/user-categories/${categoryId}`);
};

export default deleteUserCategoriesService;
